import { log } from '../../services/utils';

import { controller } from '../../contexts/DashboardContext';

import { noraApiRequest } from './';

export const getActivityList = async ( {
	begin = new Date( new Date().setDate( new Date().getDate() - 90 ) ).toLocaleDateString(),
	end = new Date().toLocaleDateString(),
	includeZZZ = false,
	includeComplete = false
} = {} ) => {
	log( '* get activity list' );
	const { data } = await noraApiRequest( {
		url: 'activity/search',
		params: {
			begin,
			end,
			includeComplete,
			includeZZZ
		},
		signal: controller.signal
	} );

	return data;
};

export const getActivityRoute = async id => {
	log( '* get activity route' );
	const { data } = await noraApiRequest( {
		url: `activity/${ id }/route`,
		signal: controller.signal
	} );

	return data;
};

export const snoozeActivity = async ( id, typeId ) => {
	log( '* snooze activity' );
	const { data } = await noraApiRequest( {
		method: 'PATCH',
		url: `activity/${ id }/snooze/${ typeId }`,
		signal: controller.signal
	} );

	return data;
};

export const setActivityStatus = async ( id, typeId ) => {
	log( '* set activity status' );
	const { data } = await noraApiRequest( {
		method: 'PATCH',
		url: `activity/${ id }/status/${ typeId }`,
		signal: controller.signal
	} );

	return data;
};
